<script lang="ts">
    import { apiBaseURL } from "../../config"
    export let collectionName: string = "content"
    export let entryId: string = null
    export let file: File = null
    export let alt: string = ""
    export let cssClass: string = ""
    export let videoFilter: string = "l"
    console.log(file)
</script>

{#if collectionName && entryId && file}
    <video
        src="{`${apiBaseURL}${collectionName}/${entryId}/${file.src}`}"
        class="{cssClass}"
        controls
        on:click
        on:keyup
    >
        <track kind="captions" />
    </video>
{/if}
